export default {
    PRIVACY_POLICY_PATH: "https://www.culturebie.com/privacy-policy",
    COOKIE_POLICY_PATH: "https://www.culturebie.com/privacy-policy",
    TERMS_AND_CONDITION_PATH: "https://www.culturebie.com/privacy-policy",
    LINKED_IN_PATH : "https://www.linkedin.com/company/culturebie/"
}